import React, { Component } from 'react';
import Loading from 'react-fullscreen-loading';
const Loader = () => {
        return (
            <div>
                <Loading loading loaderColor="#f55d2c" />
            </div>
        );
}

export default Loader;